import React from 'react';

import { getHierarchyByConfig, getModuleData, setI18nDataByConfig } from '@/common/data';
import ErrorBoundary from '@/common/error-boundary';

export default function Layout(
  props: DetailTypes.Root & {
    components: {
      [key: string]: () => React.JSX.Element;
    };
  }
) {
  const { nodeMap, devData, globalData, components } = props;
  //页面容器结构
  const hierarchy = getHierarchyByConfig(devData, globalData, props.hierarchy);
  const { structure } = hierarchy || {};

  // 多语言实验支持配置
  setI18nDataByConfig(devData, globalData);

  // 动态渲染组件
  const renderComponent = (keyword: string) => {
    const { moduleName } = nodeMap[keyword];

    if (!moduleName) return null;
    const Component = components[moduleName];
    if (!Component) return null;

    return (
      <ErrorBoundary module={keyword} key={keyword}>
        {/* 自动曝光打点 */}
        <div detail-module-name={keyword} className={keyword}>
          <Component {...getModuleData(keyword, props)} />
        </div>
      </ErrorBoundary>
    );
  };

  // 渲染模块
  const renderLayout = (item: string) => {
    const layout = structure[item];
    // 渲染容器
    if (Array.isArray(layout)) {
      return <div className={item}>{layout.map(i => renderLayout(i))}</div>;
    } else {
      // 渲染组件
      if (nodeMap[item]) {
        return renderComponent(item);
      }
      // 空元素
      else {
        return <div id={item}></div>;
      }
    }
  };

  return renderLayout('root');
}
